<div class="text-info"><p>{{ info.Response }}</p></div>

<div class="text-info">
  <p *ngIf="info && info.ReadValue"><b>{{'report_reader_value' | translate}}: </b>{{info.ReadValue}}</p>
  <p *ngIf="info && info.UserReadValue"><b>{{'reader_manual_input' | translate}}: </b>{{info.UserReadValue}}</p>
</div>
